module.exports = __webpack_public_path__ + "img/61.a2c695e6.jpg";